export const customParamsStyle = {
  '#customParametersSettings': {
    '& .custom-param__key-field': {
      width: '155px',
      display: 'inline-block',
    },
    '& .closeimage.custom-param__close-button': {
      position: 'static',
    },
    '& .custom-param__value-field': {
      width: '260px',
      display: 'inline-block',
    },
    '& .custom-param-entry': {
      '& .control-label': {
        display: 'inline-block',
      },
      '& input.form-control': {
        display: 'inline-block',
      },
      '& label.control-label': {
        display: 'inline-block',
        marginLeft: '5px',
        marginRight: '5px',
      },
    },
    '& .custom-param__key-container': {
      display: 'inline-block',
    },
    '& .flex-row-dynamic': {
      verticalAlign: 'initial',
    },
  },
  '.custom-parameters': {
    width: 600,
  },
  '.bidding-strategy__container': {
    '& .custom-param__key-field': {
      display: 'inline-block',
      width: '85px',
      'margin-left': '5px',
      'margin-right': '5px',
    },
    '& #currencyLabelTargetCpa': {
      display: 'inline-block',
      'vertical-align': 'initial',
      marginTop: 0,
    },
    '& #currencyLabelTargetRoas': {
      display: 'inline-block',
      'vertical-align': 'initial',
      marginTop: 0,
    },
    '& .alert.alert-info': {
      marginTop: 8,
    },
    '& .alert-image': {
      paddingTop: 3,
    },
    '& a.helpbutton': {
      'margin-left': '5px',
    },
  },
};
